import * as React from 'react'
import AlertsLandingPageContainer from './AlertsLandingPage/AlertsLandingPageContainer'
import AlertsListPageContainer from './AlertsListPage/AlertsListPageContainer'
import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import { State } from './AlertsListPage/AlertsListPage'
import './AlertsPageHandler.css'

export type ExternalProps = {
  alertId?: string
}

export type ValueProps = {
  hasAlerts: boolean
  loadingAlerts: boolean
}

export type EventProps = {
  fetchAlertsMeta: () => void
}

export type Props = ValueProps & ExternalProps

export type AllProps = Props & EventProps

export default class AlertsPageHandler extends React.Component<AllProps, State> {
  
  componentWillMount() {
    if (!this.props.hasAlerts) this.props.fetchAlertsMeta()
  }
  
  render() {
    return this.props.hasAlerts ? <AlertsListPageContainer alertId={this.props.alertId}/> :
    !this.props.loadingAlerts ? (<AlertsLandingPageContainer/>) : (<div className={'alerts-page-handler-loading'}><Spinner/></div>)
  }
}